export const initialState = {
  appState: {
    status: ''
  },
  authState: {
    authenticated: false
  },
  contentState: {
    content: [{ folder: { id: 'root' }, items: [] }]
  }
};
